import React, { useState, useEffect } from 'react';
import { Tile, TileHeader, TileTitle, DropDown, ToolTip, Message } from 'cantarus-react-ui';
import { MessageStrings, TemplateGroupStrings as Strings } from '../../utils/config';
import * as templateGroupApi from '../../api/templateGroupApi';
import Spinner from '../common/Spinner'
import './styles.css'



const TemplateGroupDropDownList = ({ onTemplateGroupChange, templateGroupId }) => {
    const [loading, setLoading] = useState(true);
    const [templateGroups, setTemplateGroups] = useState([]);
    const [templateGroupDescription, setTemplateGroupDescription] = useState('');

    let selectedOption = null
    const dropdownPlaceholder = templateGroups.length === 0 ? Strings.noGroupsPlaceholder : Strings.placeholder;
    const dropdownOptions = templateGroups.map(templateGroup => {
        const option = { value: templateGroup.Id, label: templateGroup.Name }
        if (option.value === templateGroupId) {
            selectedOption = option
        }
        return option
    })

    useEffect(() => {
        const fetchTemplateGroups = async () => {
            const groups = await templateGroupApi.getAllGroups(templateGroupId);
            setTemplateGroups(groups);
        }
        setTimeout(() => setLoading(false), 750);
        fetchTemplateGroups();

    }, []);

    useEffect(() => {
        if (templateGroupId > 0) {
            const templateGroup = templateGroups.find(group => group.Id === templateGroupId);

            setTemplateGroupDescription(templateGroup ? templateGroup.Description : '');

        }
    }, [templateGroups, templateGroupId])

    return (
        <Tile>
            <TileHeader>
                <TileTitle>{Strings.header}</TileTitle>
            </TileHeader>
            {
                loading ?
                    <Spinner /> :
                    <div>
                        {
                            templateGroups.length === 0 &&
                            <Message
                                text={MessageStrings.noGroupsFound}
                                classes={['info']} />
                        }
                        <DropDown
                            onChange={(group) => onTemplateGroupChange(group.value)}
                            placeholder={dropdownPlaceholder}
                            disabled={templateGroups.length === 0}
                            options={dropdownOptions}
                            selected={selectedOption}
                        />
                        <div className="td-group-desc-tooltip">
                            {templateGroupDescription && <ToolTip text={templateGroupDescription} />}
                        </div>
                    </div>
            }
        </Tile >
    );

};

export default TemplateGroupDropDownList;
